module.exports = {
  siteTitle: 'The Horbury Ossett Community News – Horbury & Ossett News and Current Affairs',
  siteTitleAlt: 'The Horbury Ossett Community News', // This allows an alternative site title for SEO schema.
  publisher: 'The Horbury Ossett Community News', // Organization name used for SEO schema
  siteDescription:
    'The Horbury Osset Community News – The Horbury & Ossett Community News is a free local weekly paper printed and distributed throughout Horbury and Ossett.',
  siteUrl: 'https://www.horburyossettnews.co.uk', // Site domain. Do not include a trailing slash! If you wish to use a path prefix you can read more about that here: https://www.gatsbyjs.org/docs/path-prefix/
  author: 'The Horbury Ossett Community News', // Author for RSS author segment and SEO schema
  authorUrl: 'https://www.horburyossettnews.co.uk', // URL used for author and publisher schema, can be a social profile or other personal site
  userTwitter: '@twitter', // Change for Twitter Cards
  shortTitle: 'Horbury Ossett News', // Used for App manifest e.g. Mobile Home Screen
  shareImage: '/logos/share.jpg', // Open Graph Default Share Image. 1200x1200 is recommended
  shareImageWidth: 1200, // Change to the width of your default share image
  shareImageHeight: 1200, // Change to the height of your default share image
  siteLogo: '/logos/logo-512.png', // Logo used for SEO, RSS, and App manifest
  backgroundColor: '#ffffff', // Used for Offline Manifest
  themeColor: '#5d94cf', // Used for Offline Manifest
  copyright: 'Copyright © 2020 Roundbox Media', // Copyright string for the RSS feed
}
